import { useState } from "react";
import ExtendLicense from "../../../shared/Extend";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deltamathAPI } from "../../utils";
import axios, { AxiosError } from "axios";
import { discriminateInvoiceType } from "../../utils/quoteUtils";
import { useDeltaToastContext } from "../../../shared/contexts/ToasterContext";
import { RENEWALS_TABLE_QUERY_KEY } from "./constants";
import { parse, set } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";

const ExtendFromRenewal: React.FC<{
  value: number;
  siteID: string;
  licenseType: string;
  schoolYear: string;
  renewalID: string;
}> = ({ value, siteID, licenseType, schoolYear, renewalID }) => {
  const toastContext = useDeltaToastContext();
  const queryClient = useQueryClient();

  const [extensionDate, setExtensionDate] = useState<number>(0);

  const dateString = new Date(value * 1000).toLocaleDateString("en-US", {
    timeZone: "America/New_York",
  });

  const zonedDateTime = zonedTimeToUtc(value, "America/New_York");

  const { mutate: handleExtend } = useMutation({
    mutationFn: async () => {
      if (licenseType === "individual") {
        throw new Error("Individual licenses cannot be extended");
      }

      await axios.put(
        `${deltamathAPI()}/manager_new/renewals/${renewalID}/extend-site-license`,
        {
          siteID,
          type: discriminateInvoiceType(licenseType),
          expiration: extensionDate,
          schoolYear,
        }
      );
    },
    onSuccess: () => {
      toastContext.addToast({
        status: "Success",
        message: "License extended successfully",
      });
    },
    onError: (error: AxiosError) => {
      toastContext.addToast({
        status: "Error",
        message:
          (error.response?.data as any)?.message ||
          "License extension failed: " + JSON.stringify(error),
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [RENEWALS_TABLE_QUERY_KEY],
      });
    },
  });

  return (
    <span className="felx-row flex items-center">
      <div>{dateString}</div>

      <ExtendLicense
        handleExtend={handleExtend}
        licenseExpiration={new Date(value * 1000)}
        extensionDate={extensionDate}
        setExtensionDate={setExtensionDate}
        schoolYear={schoolYear}
      />
    </span>
  );
};

export default ExtendFromRenewal;
